<template>
  <div>
    <el-dialog
      width="30%"
      :visible="visible"
      title="提示"
      @close="$emit('update:visible', false)"
    >
      <div
        slot="title"
        class="Diatitle">
        <span>电池记录集合</span>
      </div>
      <div class="data_div">
        <p>电池编号:{{batteryData.bmsNo}}</p>
        <p>终端类型:{{batteryData.terminalType}}</p>
        <p>终端时间:{{batteryData.t}}</p>
        <p>原始数据:{{batteryData.devData}}</p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    batteryData: {
      type: Object
    },
    visible:{
      type:Boolean
    }
  },
  data() {
    return {
      batteryVisible: false,
    };
  },
  watch: {
    
  },
  methods: {
    
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__headerbtn {
  top: 12px !important;
}
.data_div{
  padding: 0  20px;
  p{
    padding: 8px 0;
    color:#333;
  }
}
.Diatitle {
  width: 100%;
  height: 42px;
  background-color: #f6f6f6;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  span {
    padding: 0 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
}
</style>
